import { render, staticRenderFns } from "./DeleteArchiveDialogBox.vue?vue&type=template&id=a4972b6a&scoped=true&"
import script from "./DeleteArchiveDialogBox.vue?vue&type=script&lang=js&"
export * from "./DeleteArchiveDialogBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4972b6a",
  null
  
)

export default component.exports